/**
 * Every API response, success or failure. `error.code` is the contract the
 * client switches on — never the HTTP status, never the message text.
 */
export interface SuccessEnvelope<T> {
	success: true;
	data: T;
	message: string;
	error: null;
}

export interface ErrorEnvelope {
	success: false;
	data: null;
	message: string;
	error: { code: ErrorCode; message: string; details?: Record<string, unknown> };
	request_id?: string;
}

export type Envelope<T> = SuccessEnvelope<T> | ErrorEnvelope;

export type ErrorCode =
	| "VALIDATION_FAILED"
	| "NOT_FOUND"
	| "CONFLICT"
	| "SERVICE_UNAVAILABLE"
	| "INTERNAL_ERROR";

/** Failures a retry can fix: the server did not answer, or a dependency of it did not. */
export const isTransient = (code: ErrorCode): boolean => code === "SERVICE_UNAVAILABLE";

export interface Paginated<T> {
	items: T[];
	page: number;
	page_size: number;
	total: number;
	total_pages: number;
}

export const PAGE_SIZE_DEFAULT = 25;
export const PAGE_SIZE_MAX = 100;
